import { toast } from 'react-toastify';
import dayjs from 'dayjs';

import {
     API_SYSTEM_ADMIN_ADD_PRODUCT_ACCESS,
     API_SYSTEM_ADMIN_DELETE_PRODUCT_ACCESS,
     API_SYSTEM_ADMIN_PRODUCT_ACCESS,
     API_SYSTEM_ADMIN_SEAT,
     TRAINING_PRODUCT_TYPES,
} from '../../../../../../../constants';
import { setIsWaiting, setRemoveLoading, setShowPopupDetail, setShowRemovePopup } from '../../../../../../../actions/general';
import { callApi } from '../../../../../../../apiCaller';
import { toastError } from '../../../../../../../utils';

export const SET_ADMIN_PRODUCT_ACCESS = 'setAdminProductAccess';

export const setProductAccess = (payload) => {
     return {
          type: SET_ADMIN_PRODUCT_ACCESS,
          payload,
     };
};

export const fetchAdminProductAccessRequest =
     (userId, { setIsLoading }) =>
     async (dispatch) => {
          setIsLoading(true);

          const response = await callApi(API_SYSTEM_ADMIN_PRODUCT_ACCESS.replace(':userId', userId), 'GET');
          setIsLoading(false);

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const getMethodAccess = (course) => {
               const product = course.product;
               const productType = product.productType?.trainingProductType;
               const productAccess = {
                    isPhysical: productType === TRAINING_PRODUCT_TYPES.PHYSICAL_PRODUCT,
                    isNonBuyProduct:
                         [TRAINING_PRODUCT_TYPES.DIGITAL_DOWNLOAD, TRAINING_PRODUCT_TYPES.TEST_ONLY].includes(productType) &&
                         product?.makeProductAvailable,
               };

               if (course.createdBy === 'admin') {
                    return 'Admin Allowed';
               }

               if (course.seat?.organizationId) {
                    return 'Assigned Seat';
               }

               if (productAccess.isPhysical && !product?.purchaseRequired && !course.seatId) {
                    return 'Attested';
               }

               if (productAccess.isNonBuyProduct) {
                    return 'Free of Charge';
               }

               return 'Purchased';
          };

          const productAccessRes = response.data.map((proAccess) => {
               const { accessedAt = '', expiredAt = '' } = proAccess.seat || {};
               let dayExpiration = 0;

               if (expiredAt) {
                    const today = dayjs();
                    const expiredDate = dayjs(expiredAt);
                    const daysToExpiration = expiredDate.diff(today, 'day') + 1;

                    dayExpiration = daysToExpiration > 0 ? daysToExpiration : 0;
               }

               return {
                    ...proAccess,
                    productName: proAccess.product?.name || '',
                    confirmAttended: proAccess.confirmAttended ? 'Yes' : '',
                    methodOfAccess: getMethodAccess(proAccess),
                    accessedAt,
                    expiredAt,
                    dayExpiration,
               };
          });

          dispatch(setProductAccess(productAccessRes));
     };

export const addAdminExpirationDaysRequest = (payload) => async (dispatch, getState) => {
     const productAccess = getState().admin.productAccess;
     const seatId = getState().general.showPopupDetail;

     dispatch(setIsWaiting(true));

     return await callApi(API_SYSTEM_ADMIN_SEAT.replace(':id', seatId), 'PUT', payload)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }

               if (response.data) {
                    const newProductAccess = [...productAccess];

                    for (let i = 0; i < newProductAccess.length; i++) {
                         const proAccess = newProductAccess[i];

                         if (proAccess.seat?.id === seatId) {
                              const plusDay = payload.days;
                              const dayExpiration = proAccess.dayExpiration > 0 ? proAccess.dayExpiration + plusDay : plusDay;

                              newProductAccess[i] = {
                                   ...proAccess,
                                   dayExpiration,
                                   expiredAt: response.data.expiredAt,
                              };
                              break;
                         }
                    }

                    dispatch(setProductAccess(newProductAccess));
               }

               toast.success('Updated successfully');
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               dispatch(setShowPopupDetail(null));
          });
};

export const addAdminProductAccessRequest = (values, nextDispatch) => (dispatch) => {
     const { setSubmitting, setShowPopupAddProductAccess } = nextDispatch;

     dispatch(setIsWaiting(true));
     setSubmitting(true);
     callApi(API_SYSTEM_ADMIN_ADD_PRODUCT_ACCESS, 'POST', values)
          .then((response) => {
               if (response.status !== 200) {
                    toastError(response);
                    return;
               }
               if (response.data) {
                    toast.success('Created successfully');
               }
               dispatch(fetchAdminProductAccessRequest(values.userId, nextDispatch));
          })
          .finally(() => {
               dispatch(setIsWaiting(false));
               setSubmitting(false);
               setShowPopupAddProductAccess(false);
          });
};

export const deleteAdminProductAccessRequest = (id) => (dispatch, getState) => {
     const productAccess = getState().admin.productAccess;

     dispatch(setRemoveLoading(true));
     callApi(API_SYSTEM_ADMIN_DELETE_PRODUCT_ACCESS.replace(':id', id), 'DELETE').then((response) => {
          dispatch(setRemoveLoading(false));

          if (response.status !== 200) {
               toastError(response);
               return;
          }

          const newProductAccess = productAccess.filter((prodAccess) => prodAccess.id !== id);
          dispatch(setProductAccess(newProductAccess));
          dispatch(setShowRemovePopup(null));
          toast.success('Deleted successfully');
     });
};
